import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import NotificationTableService from '../service/NotificationTableService';

const config = {
	key: 'notificationTable',
	topic: 'notification',
	service: NotificationTableService,
	// editFormState: item => `/aspect/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh'],
	rowAction: ['delete'],
	columns: [
		{
			key: 'message'
		},
		{
			key: 'created',
			type: 'dateTime'
		},
		{
			key: 'notificationType'
		},
		{
			key: 'severity'
		},
		{
			key: 'read'
		}
	]
};

function NotificationTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('notificationTable', reducer('notificationTable'))(NotificationTable);
